<template>
    <nav id="navigation" class="navbar bng-topbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a
                @click="goHome"
                class="topbar-logo-link">
                <img v-if="logo" :src="logo" class="topbar-logo" />
                <span v-else class="topbar-title">{{title}}</span>
            </a>
            <a role="button" class="navbar-burger burger" @click="toggleMenu" :class="{'is-active': isActiveMenu}">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div v-if="showBars" class="navbar-menu">
            <topbar-start />
        </div>
        <topbar-end />
    </nav>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import TopbarStart from './topbar-start.vue';
import TopbarEnd from './topbar-end.vue';

export default {
    name: 'topbar-1',
    components: { TopbarStart, TopbarEnd },
    data() {
        return {
            isActiveMenu: false,
            isMobile: isMobile.phone || isMobile.tablet,
            logo: null,
            title: null,
            logoRoute: '/'
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        showBars() {
            return this.isLoggedIn || !this.client.view.auth.authenticationHideBars;
        }
    },
    watch: {
        $route(to, from) {
            // hide menu on mobile devices after click on menu item
            this.isActiveMenu = false;
        },
        isActiveMenu() {
            this.callingEventMobileMenu();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.logo = this.isMobile ? (client.view.style.logoMobile || client.view.style.logo) : client.view.style.logo;
        this.title = client.view.general.alias;
    },
    methods: {
        async goHome() {
            await Vue.router.teleport.home();
        },
        toggleMenu() {
            this.isActiveMenu = !this.isActiveMenu;
            this.callingEventMobileMenu();
        },
        callingEventMobileMenu() {
            this.$emit('changeOpeningMobileMenu', {
                'isOpen': this.isActiveMenu
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-1.vue